function setupStripeResponseHandler(campaignId) {
  window.stripeResponseHandler = function(status, response) {
    var form = $('#payment-form');
    if (response.error) {
      var errorMessage = response.error.message;
      var friendlyMessages = {
        'exp_month': 'Please enter two digits between 01 and 12 for the expiry month of your card.',
        'exp_year': 'Please enter four digits for the expiry year of your card.'
      };
      for (var key in friendlyMessages) {
        if (errorMessage.indexOf(key) !== -1) {
          errorMessage = friendlyMessages[key];
          break;
        }
      }
      form.find('.payment-errors').text(errorMessage);
      form.find('button').prop('disabled', false);
      $('.js-donation-processing').hide();
      $('.js-donation-details').show();
    } else {
      var token = response.id;
      form.append($('<input type="hidden" name="stripeToken" />').val(token));
      $.ajax({
        url: form.attr('action'),
        data: form.serialize(),
        method: 'POST',
        dataType: 'json'
      }).done(function(data) {
        if (typeof data.error === 'undefined') {
          if (trackersGoogleAnalytics.enabled) {
            ga('send', 'event', 'donation', 'complete', campaignId);
          }
          window.location = data.redirect_url;
        } else {
          alert(data.error);
          form.find('button').prop('disabled', false);
          $('.js-donation-processing').hide();
          $('.js-donation-details').show();
        }
      });
    }
  };
}

function bindValidateCreditCard() {
  $('.js-card-number').validateCreditCard(function(result) {
    $(this).removeClass(function (index, css) {
      return (css.match (/(^|\s)type-\S+/g) || []).join(' ');
    });
    if (result.card_type !== null) {
      $(this).addClass('type-' + result.card_type.name);
    }
    if (result.length_valid) {
      $(this).addClass('valid').removeClass('invalid');
    }
    else {
      $(this).addClass('invalid').removeClass('valid');
    }
  });
}

function bindPaymentFormSubmission() {
  $('#payment-form').submit(function(e) {
    var $form = $(this);

    // validate the form
    if ($('.js-card-number').hasClass('invalid')) {
      show_validation_error($('.js-card-number').parent(), true, "Please check your card number is correct");
      return false;
    }

    $form.find('button').prop('disabled', true);
    $('.js-donation-details').hide();
    $('.js-donation-processing').show();
    Stripe.card.createToken($form, stripeResponseHandler);
    return false;
  });
}


/*** EXPORTS FROM exports-loader ***/
exports["setupStripeResponseHandler"] = (setupStripeResponseHandler);
exports["bindValidateCreditCard"] = (bindValidateCreditCard);
exports["bindPaymentFormSubmission"] = (bindPaymentFormSubmission);